import Router from "next/router";

import { Menu } from "../types/Menu";
import CloseIcon from "icons/CloseIcon";
import { Row, Spacing } from "helpers/layout";
import { Wrapper } from "./Wrapper";
import { useState } from "react";
import { css } from "styled-components";
import { Colors } from "branding";
import { IN_PAGE_MENU_MOBILE_LEVEL } from "helpers/zIndex";
import { ItalicTitle } from "typography";
import { PlainButton } from "./PlainButton";
import ArrowRight from "icons/ArrowRight";
import { Scrollbar } from "./Scrollbar";
import { getLinkParams } from "./Link";

const MenuItems = ({
  menu,
  open,
  closeMenu,
}: {
  menu: Menu;
  open: boolean;
  closeMenu: () => void;
}) => {
  return (
    <Row
      gutter={Spacing.none}
      css={css`
        position: absolute;
        background: ${Colors.very_light_grey};
        transform: ${open ? "translateX(0%)" : "translateX(100%);"}
        opacity: ${open ? 1 : 0};
        transition: transform 0.3s ease-in, opacity 0.3s ease-in;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: ${open ? "auto" : "none"};

        .Scrollbar__arrows-inside {
          height: 100%;
          padding: 0;
        }
        .Scrollbar__arrow-left,
        .Scrollbar__arrow-right {
          display: none;
        }
      `}
    >
      <div
        css={css`
          position: absolute;
          height: 100%;
          right: 0;
          width: ${Spacing.xxxl};
          background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            ${Colors.very_light_grey} 80%
          );
          z-index: ${IN_PAGE_MENU_MOBILE_LEVEL + 1};
          pointer-events: none;
        `}
      />
      <Scrollbar autoHeight onlyArrows arrowsInside>
        <Row
          align="center"
          css={css`
            height: 100%;
            padding-right: ${Spacing.xxxl};
          `}
        >
          {menu.items.map((item, i) => {
            return (
              <div
                key={`${item.uuid}-${i}`}
                css={css`
                  display: flex;
                  height: 60px;
                `}
              >
                <PlainButton
                  css={`
                    span {
                      white-space: nowrap;
                      text-transform: uppercase;
                    }
                  `}
                  type="button"
                  onClick={() => {
                    const { href, as } = getLinkParams(
                      item.url,
                      item.new_window,
                    );

                    Router.push(href, as);
                  }}
                  underlined
                >
                  {item.name}
                </PlainButton>
              </div>
            );
          })}
        </Row>
      </Scrollbar>
      <div
        css={css`
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          position: relative;
          z-index: ${IN_PAGE_MENU_MOBILE_LEVEL + 1};
        `}
        onClick={() => closeMenu()}
      >
        <CloseIcon />
      </div>
    </Row>
  );
};

export function InPageMobileMenuScroller({
  menu,
  name,
  notSticky = false,
}: {
  menu: Menu | null;
  name: string;
  notSticky?: boolean;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div
      css={css`
        display: flex;
        position: relative;
        transition: top 0.2s ease-in-out 0s;
        transform: translate3d(0px, 0px, 0px);
        background: ${Colors.very_light_grey};
        z-index: ${IN_PAGE_MENU_MOBILE_LEVEL};
        width: 100%;
        height: 60px;
        box-sizing: border-box;
        overflow: hidden;

        ${!notSticky &&
        css`
          position: sticky;
          top: 0;

          body.header-pinned & {
            top: 70px;
          }
        `}
      `}
    >
      <Wrapper
        type="header"
        css={css`
          display: flex;
        `}
      >
        <Row
          css={css`
            width: 100%;
            position: relative;
          `}
          justify="space-between"
          gutter={Spacing.s}
        >
          <ItalicTitle
            css={css`
              font-size: 18px;
              align-self: center;
              opacity: ${!open ? 1 : 0};
              transition: opacity 0.1s ease-in-out;
              max-width: 60%;
            `}
          >
            {name}
          </ItalicTitle>
          {menu && (
            <>
              <PlainButton
                css={css`
                  display: flex;
                  align-items: center;
                  align-self: center;
                  text-transform: uppercase;
                  span {
                    font-size: 11px;
                    white-space: nowrap;
                  }
                `}
                icon={<ArrowRight />}
                iconPosition="right"
                onClick={() => setOpen(true)}
              >
                {menu.mobile_menu_label || "Series Menu"}
              </PlainButton>
              <MenuItems
                open={open}
                menu={menu}
                closeMenu={() => setOpen(false)}
              />
            </>
          )}
        </Row>
      </Wrapper>
    </div>
  );
}
